<template>
  <section>
    <section class="events">
      <div class="cover_img">
        <img src="../../assets/img/events_cover.png" />
        <h2>Gallery</h2>
      </div>
      <div class="container">
        <div class="funding_text">
          <h6>A Fund Rising Event</h6>
        </div>
      </div>
    </section>
    <div id="events" class="container" style="padding-bottom: 120px">
      <div class="offset">
        <div class="post_body" v-for="(p, index) in displayedPosts" :key="index">
          <div class="row" v-if="index % 2 == 1">
            <div class="col event_post">
              <div class="body">
                <h2>{{ p.header_text }}</h2>
                <p>{{ p.discription }}</p>
                <h4>
                  <i class="fas fa-circle"></i>
                  {{ p.date }}
                </h4>
                <p>{{ p.time }}</p>
                <h4>
                  <i class="fas fa-map-marker-alt"></i>
                  {{ p.location }}
                </h4>
                <router-link to="/event_view">
                  <button>
                    {{ p.button }}
                    <div class="long-arrow-left active long_right"></div>
                  </button>
                </router-link>
              </div>
            </div>
            <div class="col event_post_photo" data-aos="zoom-in">
              <figure><img :src="p.image" /></figure>
            </div>
          </div>
          <div class="row right_side" v-if="index % 2 == 0 && index != 0">
            <div class="col event_post">
              <div class="body">
                <h2>{{ p.header_text }}</h2>
                <p>{{ p.discription }}</p>
                <h4>
                  <i class="fas fa-circle"></i>
                  {{ p.date }}
                </h4>
                <p>{{ p.time }}</p>
                <h4>
                  <i class="fas fa-map-marker-alt"></i>
                  {{ p.location }}
                </h4>
                <router-link to="/event_view">
                  <button>
                    {{ p.button }}
                    <div class="long-arrow-left active long_right"></div>
                  </button>
                </router-link>
              </div>
            </div>
            <div class="col event_post_photo" data-aos="zoom-in">
              <figure><img :src="p.image" /></figure>
            </div>
          </div>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item">
              <div type="button" class="page-link next_button" @click="previews()">
                <div v-if="page != 1" class="long-arrow-right active"></div>
                <div v-if="page == 1" class="long-arrow-right unactive"></div>
              </div>
            </li>
            <li class="page-item" v-for="pageNumber in pages" :key="pageNumber.id">
              <div
                type="button"
                v-if="pageNumber == page"
                @click="page = pageNumber"
                class="is-primary page-link"
              >
                {{ pageNumber }}
              </div>
              <div
                type="button"
                v-if="pageNumber in pages.slice(page - 1, page + 4)"
                @click="page = pageNumber"
                class="page-link"
              >
                {{ pageNumber }}
              </div>
            </li>
            <li class="page-item">
              <div type="button" @click="next()" class="page-link next_button">
                <div
                  v-if="page < pages.length - 1"
                  class="long-arrow-left unactive"
                ></div>
                <div v-if="page < pages.length - 4" class="long-arrow-left active"></div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      posts: [""],
      page: 1,
      perPage: 4,
      pages: [],
      pageCount: 0,
    };
  },
  methods: {
    getPosts() {
      for (let i = 0; i < 20; i++) {
        this.posts.push({
          header_text: i + "A Fund Rising Event",
          discription:
            "Our most popular service is our Virtual Receptionist. We know that sometimes it’s difficult to get to the phone if you are in the middle of something and you don’t want to miss that important call that could be the start of an exciting new business opportunity, so let us answer it for you.",
          date: "December 6 - December 9",
          time: "December 6 2020 09:00 AM to December 9 2020 09:00 PM",
          location: "Dhaka,Bangladesh",
          // image: "@/assets/img/event_1.png",
          image: require('../../assets/img/event_1.png'),
          button: "Details",
        });

        this.posts.push({
          header_text: i + "A Fund Rising Event",
          discription:
            "Our most popular service is our Virtual Receptionist. We know that sometimes it’s difficult to get to the phone if you are in the middle of something and you don’t want to miss that important call that could be the start of an exciting new business opportunity, so let us answer it for you.",
          date: "December 6 - December 9",
          time: "December 6 2020 09:00 AM to December 9 2020 09:00 PM",
          location: "Dhaka,Bangladesh",
          // image: "@/assets/img/event_2.png",
          image: require('../../assets/img/event_2.png'),
          button: "Details",
        });
      }
    },
    setPages() {
      let numberOfPages = Math.ceil(this.posts.length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate() {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      let pageCount;
      if (page == 0) page = 1;
      if (page < 0) page = pageCount;
      else if (page > pageCount) page = pageCount;
      this.pageCount = pageCount;
      return this.posts.slice(from, to);
    },
    previews() {
      if (this.page > 1) {
        this.page -= 1;
        this.paginate({
          page: this.page,
          perPage: this.perPage,
        });
      }
    },
    next() {
      if (this.page < this.pages.length - 4) {
        this.page += 1;
        this.paginate({
          page: this.page,
          perPage: this.perPage,
        });
      }
    },
  },
  computed: {
    displayedPosts() {
      return this.paginate(this.posts);
    },
  },
  watch: {
    posts() {
      this.setPages();
    },
  },
  created() {
    this.getPosts();
  },
  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },
};
</script>
<style scoped>
.page-link.next_button {
  color: #fff0 !important;
}
.event_post .long_right {
  position: relative;
  margin-top: 14px;
  zoom: 0.6;
}
.long-arrow-left,
.long-arrow-right {
  display: block;
  margin: 0px auto;
  width: 15px;
  height: 15px;
  position: absolute;
}
.long-arrow-left.active,
.long-arrow-right.active {
  border-top: 1px solid #07cddb;
  border-left: 1px solid #07cddb;
}
.long-arrow-left.active::after,
.long-arrow-right.active::after {
  background-color: #07cddb;
}

.long-arrow-right {
  transform: rotate(-45deg);
  margin-left: -45px;
  margin-top: 4px;
  zoom: 0.7;
}
.long-arrow-left {
  transform: rotate(135deg);
  margin-left: 35px;
  margin-top: 4px;
  zoom: 0.7;
}
.long-arrow-left::after,
.long-arrow-right::after {
  content: "";
  display: block;
  width: 1px;
  height: 35px;

  -webkit-transform: rotate(-45deg) translate(15px, 4px);
  transform: rotate(-45deg) translate(11.5px, 5px);
  left: 0;
  top: 0;
}
.page-link .fa-long-arrow-alt-right {
  position: absolute;
  margin-top: 0px;
}
.event_post_photo img {
  padding: 0px;
  width: 100%;
  float: right;
}
.next_button {
  margin-left: 0px !important;
}
.is-primary {
  color: #221f1f !important;
  background-color: #07cddb !important;
  position: absolute !important;
  z-index: 1011;
  border-radius: 50%;
  height: auto;
  width: auto;
  padding: 0.35rem 0.7rem !important;
  font-weight: 700;
  margin-top: 2px;
}
.event_post_photo img {
  -webkit-transform: rotate(0) scale(1);
  transform: rotate(0) scale(1);
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
.event_post_photo:hover img {
  -webkit-transform: rotate(15deg) scale(1.5);
  transform: rotate(15deg) scale(1.5);
  opacity: 0.9;
}
#events .event_post h4 {
  margin-left: 25px;
}
#events .fa-map-marker-alt {
  color: #07cddb;
  font-size: 20px;
  padding-top: -17px;
  position: absolute;
  margin-left: -20px;
  padding-right: -110px;
  background: #fff;
  height: 0px;
  padding: 8px 0px 3px 0px;
  border-radius: 50%;
  padding-left: -10px;
  margin-top: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 10px;
}
#events .fa-circle {
  color: #07cddb;
  font-size: 17px;
  position: absolute;
  margin-left: -25px;
  margin-top: 5px;
}
.events .funding_text {
  margin-left: auto;
  margin-right: 1rem;
  text-align: right;
  margin-bottom: -rem;
  margin-top: -3rem;
}
.events .funding_text h6 {
  font-weight: 500;
  color: #707070;
}
.event_post {
  display: flex;
  justify-content: center;
  align-items: center;
}
#events .post_body {
  padding-bottom: 60px;
}
.event_post a {
  color: #fff;
}
.event_post h2 {
  padding: 10px 0px;
}
.event_post p {
  padding: 10px 0px;
}
.event_post button {
  text-align: left;
  font: normal normal normal 18px/22px Proxima Nova;
  letter-spacing: 0px;
  color: #07cddb;
  opacity: 1;
  padding: 30px 0px;
  display: flex;
}
.event_post button i {
  padding: 0px 10px;
  position: absolute;
  margin-top: 4px;
}
.right_side {
  flex-direction: row-reverse;
}
.right_side .event_post_photo img {
  float: left;
}
#events .page-link {
  position: relative;
  display: inline-block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  background-color: #fff0;
  border: 0px solid #dee2e6;
}
#events nav {
  display: flex;
  justify-content: center;
  align-items: center;
}
figure {
  margin: 0;
  padding: 0;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}
figure:hover + span {
  bottom: -36px;
  opacity: 1;
}
</style>
